import Task from './Task'
import merge from '../functions/merge'

export default merge(Task, {
	entity() {
		return merge(Task.entity(), {
			type: 'move',
			details: {
				route: [],
				driving: 30,
				cubic: '',
				packaging: {},
				type: '2',
				date_type: 'default'
			}
		});
	}
});